<template>
  <v-layout row justify-end align-center wrap>
    <v-flex>
      <v-tabs
        :value="openTab"
        @change="$emit('update-open-tab', $event)"
        slider-color="accent"
        background-color="transparent"
      >
        <v-tab
          v-for="tab in tabs"
          :key="tab.value"
          :href="'#' + tab.value"
          :disabled="tab.disabled"
          ripple
          style="text-transform: none; font-size: 12px"
        >
          {{ tab.text }}
        </v-tab>
      </v-tabs>
    </v-flex>

    <v-flex class="management-tab" v-if="openTab !== 'map'">
      <v-tabs-items v-model="openTab">
        <v-tab-item
          v-for="tab in tabs"
          :key="tab.value"
          :value="tab.value"
          class="mt-3"
        >
          <v-text-field
            v-if="search && tab.hasSearch"
            :value="search[tab.value]"
            @input="$emit('update-search', { tab: tab.value, value: $event })"
            append-icon="search"
            :label="$t('Search')"
            :placeholder="$t('Search')"
            single-line
          />
        </v-tab-item>
      </v-tabs-items>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: "ManagementTabsAndSearch",

  props: {
    /**
     * Receive the available tabs
     */
    tabs: {
      type: Array,
      required: true
    },

    /**
     * Determines which tab is selected
     */
    openTab: {
      type: String,
      required: true
    },

    /**
     * Receive the search value
     */
    search: {
      type: Object
    }
  }
};
</script>

<style>
.management-tab .v-window__container {
  transition: none !important;
}
.management-tab .v-tabs-items {
  background-color: transparent !important;
}

.management-tab .v-text-field > .v-input__control > .v-input__slot:before,
.management-tab .v-text-field > .v-input__control > .v-input__slot:before {
  border-style: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/_Organisms/ManagementTabsAndSearch.vue